import {ActionTree} from 'vuex'
import {WidgetState} from "@/apps/StudentExchangeProgressColumnWidget/models/store-viewmodel"
import {ILabels} from "@/apps/StudentExchangeProgressColumnWidget/models/config-viewmodel"

export default <ActionTree<WidgetState, any>>{
    setLabels(context, payload: ILabels): void {
        context.commit('labels', payload)
    },
    setProgressLabels(context, payload: []): void {
        context.commit('progressLabels', payload)
    }
}
